<template>
    <div id="homePage" v-loading="loading"
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-text="先喝杯茶～～"
    class="homePage"
    >
        <div class="banner" id="banner">
    <el-carousel trigger="click" height="460px"
    :interval="5000"
    :autoplay="true"
    >
      <el-carousel-item v-for="(item,index) in banner" :key="index">
           <div class="banner-list">
              <img :src="item.picUrl" alt="" style="height:460px;width:100%" v-if="getResourceType(item.picUrl) == 'img'">
                <VideoPlay
                v-show="true"
                :videoUrl="item.picUrl"
                :height="460"
                :autoplay="true"
                :controls="false"
                :loop="true"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :playWidth="96"
                zoom="cover"
                v-if="getResourceType(item.picUrl) == 'video'"
              />
           </div>
           <div class="banner-description">
            <div class="name" v-if="getResourceType(item.picUrl) != 'video'">{{item.name}}</div>
             <div class="description" v-if="getResourceType(item.picUrl) != 'video'">{{item.description}}</div>
             <div class="btn" @click="openBannerView(item)"
             :class="{mobileVid: getResourceType(item.picUrl) == 'video'}"
             :style="getResourceType(item.picUrl) == 'video' ? {'margin-top':'100px'} : ''"
             >立即查看</div>
           </div>
      </el-carousel-item>
    </el-carousel>
        </div>
        <div class="homePage-content">
             <!-- 产品应用 -->
            <div class="apps-show">
                <div class="title">
                    {{list.title1}}
                </div>
                <div class="apps-show-con">
                    <div class="className flex align-cen"
                >
                    <div class="product-service-title-item"  v-for="(item,index) in itemList" ::key="item.id"
                    @click="gethisList(item.id,index)"
                    >
                    <div class="product-service-title"
                    :class="index == textActive  ? 'text-active-color': ''"
                  @mouseover=" changeimg(index)"
                    @mouseout="changeimg1(index,testy)"
                    >
                    <div class="title-img" 
                    :style="{'background-image':'url(' + item.logo + ')',
                    'background-position-y':index == moveIndex ? testy :'0px'}"
                    v-if="item.logo"
                    >
                        <!--  v-if="item.logo"  -->
                    </div>
                    <div class="title-desc"  :class="index == textActive1  ? 'text-active-color1': ''">{{item.name}}</div>
                    <div class="title-content-underLine"></div>
                    </div>
                    </div>
                </div>
                <div class="ace-view-fullColumn">
                    <div class="ace-view-center flex align-cen"  v-if="dataList.length">
                        <div class="card"
                        v-for="(item, index) in dataList"
                         :key="index"
                         @click="openApp(item,1)"
                        >
                             <img :src="item.thumb" alt="">
                              <div class="card-name">{{item.appName}}</div>
                        </div>
                    </div>
                     <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
                        <span class="icon-al-wind-cry"></span>
                        <p>暂无数据</p>
                 </div> 
                </div>
                </div>
            </div>
            <!-- 解决方案 -->
            <div class="apps-show solutionbox">
                <div class="mask"></div>
                 <div class="title">
                    {{list.title2}}
                </div>
                <div class="solution flex">
                    <div class="solutionLeft">
                        <div class="jfItems">
                            <div class="itemInfo">
                                <div class="ltop">{{fristName}}解决方案</div>
                                <div class="lbottom">
                                    <div class="item  clearfix">
                                        <div class="items"
                                         v-for="(item, index) in dataList1"
                                         :key="index"
                                         @click="openApp(item,2)"
                                        >
                                        <span class="spri" 
                                        :class="randomFun()"
                                        ></span>
                                        <div class="jftitle">
                                            {{item.name}}
                                        </div>
                                         <div class="info">{{item.description}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div class="solutionRight">
                        <ul class="nav">
                            <li
                    v-for="(item,index) in itemList1" :key="item.id"
                     @click="gethisList1(item.id,index,item.name)">
                     <div class="li-row"  :class="index == text1Active  ? 'text1-active-color': ''">
                        <span>{{item.name}}</span>
                     </div>
                     </li>
                        </ul>
                </div>
                </div>
            </div>
            <!-- 移动端解决方案 -->
             <div class="apps-show mobileSolutionbox">
                 <div class="title">
                    {{list.title2}}
                </div>
                <div class="ispadding">
                    <div class="sidebar">
                        <div></div>
                        <el-collapse 
                            v-model="activeName"
                            accordion
                            >
                            <div   v-for="(item,index) in itemList1" :key="item.id"
                               @click="gethisList1(item.id,index,item.name)">
                             <el-collapse-item 
                               :title="item.name"
                            :name="item.id"
                             >
                             <div class="in-sidebar">
                                <div class="titleTit">
                                    <span>{{fristName}}解决方案</span>
                                </div>
                                <div class="isItem">
                                    <div class="items flex"
                                        v-for="(item1, index1) in dataList1"
                                         :key="index1"
                                     @click="openApp(item1,2)"
                                    >
                                     <span class="spri" 
                                        :class="randomFun()"
                                    ></span> 
                                    <div class="planInfo">
                                        <div class="planInfo-title">{{item1.name}}</div>
                                        <div class="info">{{item1.description}}</div>
                                    </div>
                                    </div>
                                </div>
                             </div>
                             </el-collapse-item>
                             </div>
                        </el-collapse>
                    </div>
                </div>
             </div>
                <!-- 推荐课程 -->
              <div class="apps-show coursebox" v-if="dataList2 && dataList2.length">
                 <div class="title">
                    推荐课程
                </div>
                <div class="course-1">
                       <div class="product-container  flex align-cen">
                             <div class="product-card"  v-for="item in dataList2" @click="openDetail(item)">
                                <img :src="item.logo" alt="">
                                  <div class="product-card-item-wrap">
                                    <div class="card-name">{{item.title}}</div>
                                    <div class="card-description">{{item.introduction}}</div>
                                    <div class="WordsLink_word-wrap">
                                        <div class="wrap-price">
                                            <div v-if="item.payType == 1" style="color:red">免费</div>
                                            <div v-else class=" flex align-cen">
                                                <div>
                                                        <span style="color:red;font-size:20px">¥{{item.minSalePrice}}起</span> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mft wrap-len" style="color:#b4b7c1;font-size:13px">已更新 {{item.chapterNum}}期</div>
                                    </div>
                                </div>
                             </div>
                        </div>
                </div>
                           <div
                         class="hz-logo-btn" @click="openCourse">
                         查看更多
                    </div>
              </div>
              <div class="apps-show logo-box" style="padding-top:0">
                 <div class="title">
                    {{list.title3}}
                </div>
                <div class="hz-logo flex align-cen">
                    <div class="hz-img"
                      v-for="(item, index) in showDeptList"
                      :key="index"
                      
                    >
                    <img :src="item.url" alt="">
                    </div>
                </div>
                                    <div v-if="list.moreImg.length > 30"
                         @click="changeFoldState"
                         class="hz-logo-btn"
                        >
                         {{flagMore?'查看更多':'收起'}}
                    </div>
              </div>
               <div class="apps-show" style="padding-top:0" v-if="list.moreTimg.length"> 
                        <div class="honor-box">
                <div class="title">
                    {{list.title4}}
                </div>
                <div class="honor-logo flex">
                    <div class="honor-img"
                     v-for="(item, index) in list.moreTimg"
                      :key="index"
                    >
                    <div class="product-grid text-center">
                        <div class="img">
                             <img src="" :src="item.url" alt="图片加载失败">
                        </div>
                    </div>
                    </div>
                </div>
                  </div>
               </div>
        </div>
        <div class="homePage-bot">
            <div class="bot-row flex align-cen">
                <div class="bot-coumln flex align-cen">
                    <img :src="list.pic1" alt="">
                  <div class="footerNon">
                      <div class="text">{{list.serveText1}}</div>
                     <div class="text1">{{list.serveBotText1}}</div>
                  </div>
                </div>
                <div class="bot-coumln flex align-cen">
                    <img :src="list.pic2" alt="">
                     <div class="footerNon">
                    <div class="text">{{list.serveText2}}</div>
                     <div class="text1">{{list.serveBotText2}}</div>
                     </div>
                </div>
                <div class="bot-coumln flex align-cen">
                    <img :src="list.pic3" alt="">
                     <div class="footerNon">
                    <div class="text">{{list.serveText3}}</div>
                     <div class="text1">{{list.serveBotText3}}</div>
                     </div>
                </div>
                <div class="bot-coumln flex align-cen">
                    <img :src="list.pic4" alt="">
                     <div class="footerNon">
                    <div class="text">{{list.serveText4}}</div>
                     <div class="text1">{{list.serveBotText4}}</div>
                     </div>
                </div>
            </div>
        </div>
         <goTop></goTop>
    </div>
</template>
<script>
import { bannerList,softList,classList,ProductList,courseIndexList} from "@/api/enterprise/index" // 轮播图列表、配置详情、分类、列表
import VideoPlay from '@/components/VideoPlay'
import imgCom from "@/components/imgCom";  //多富文本组件
import goTop from '@/components/goTop'
import debounce from '../../utils/debounce.js' //防抖
export default {
    name:'homePage',
     components:{
       VideoPlay,
       imgCom,
       goTop
    },
    data () {
        return {
            flagMore:true,
            activeName:[],
            moveIndex:'-1',
            testy:'0px',
            testinterval:null,
            alIcon:{
                nowStep:0,//当前是第几张图片;
                maxStep:21,//最多有几张图片;
                height:64,
                isOver: true, //鼠标是否移动上面了;
                active: false //是否需要动起来;
            },
            fristName:'',
            loading:true,
            banner:[],
            fristId:'',
            fristId1:'',
            itemList:[],
            itemList1:[],
            textActive:0,
            textActive1:0,
            dataList:[],
            dataList1:[],
            dataList2:[],
            text1Active:0,
            list:{
                      moreTimg:[],
                      moreImg:[],
                      title1:'',
                      title2:'',
                      title3:'',
                      title4:'',
                      pic1:'',
                      pic2:'',
                      pic3:'',
                      pic4:'',
                      serveText1:'',
                      serveText2:'',
                      serveText3:'',
                      serveText4:'',
                      serveBotText1:'',
                      serveBotText2:'',
                      serveBotText3:'',
                      serveBotText4:''

            }
        }
    },
    computed:{
          //改属性是根据计算得到（get set），计算属性中的名字不能跟data里面重名
    showDeptList: {
      get() {
        if (this.flagMore) {
          if (this.list.moreImg.length <30) {
            return this.list.moreImg
          }
          let newArr = [];
          for (let i = 0; i < 30; i++) {
            let item = this.list.moreImg[i]
            newArr.push(item)
          }
          return newArr
        }
        return this.list.moreImg
      }
    }
    },
    activated() {
    },
    created () {
        let that = this
            this.getDetail()
        this.getBanner()  
        this.gethisClass()
        this.gethisClass1()
        this.getCourse()
         //    异步同步执行
        //     .then(res =>{
        //     that.loading = false
        //     console.log(res)
        //     that.gethisList(that.fristId,0)
        //     })
        //  .then(function(){
        //     that.gethisList1(that.fristId1,0)
        //     })
    },
    mounted() {
         window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
    },
    methods: {
         // 打开课程
        openCourse(){
            this.$router.push('/webenterpriseHlrj/course')
        },
           openDetail(data){
         this.$router.push({
            name:'HlrjenCourseDetail',
            query: {
              id: data.id
            }
         })
        },
          getCourse(){
            courseIndexList({id:'',payType:'',classifyId:'',recommend:1})
            .then(res =>{
                this.dataList2 = res.data
            })
        },
        changeFoldState(){
            this.flagMore = !this.flagMore
        },
        // 解决方案图标随机函数
        randomFun(){
            let Arr = ["icon-al-applicationgroup","icon-al-monitoring","icon-al-application","icon-al-databaseset-fill","icon-al-gallery-view","icon-al-Directory-tree"];
            let n = Math.floor(Math.random() * Arr.length + 1)-1;
            return Arr[n]
        },
        //产品分类动态效果
        bgMove(){
                       var flag = true;
                       if(this.alIcon.active){
                         flag = false;
                         if(this.alIcon.isOver){
                          if(this.alIcon.nowStep < (this.alIcon.maxStep-1)){
                            this.alIcon.nowStep++;
                            this.alIcon.nowStep = this.alIcon.nowStep
                            this.testy = this.alIcon.nowStep * -this.alIcon.height + 'px'

                        }else{
                            this.alIcon.active = false
                        }
                         }else{
                            if( this.alIcon.nowStep > 0){
                                 this.alIcon.nowStep--;
                                 this.alIcon.nowStep = this.alIcon.nowStep
                                 this.testy = this.alIcon.nowStep * -this.alIcon.height + 'px'
                            }else{
                                this.alIcon.active = false
                            }
                         }
                
                       }
                       if(flag){
                            window.clearInterval(this.interval);
                       }
                    }, 
        // 分类移入移出
        changeimg(activeImg){
            this.moveIndex = activeImg
             this.textActive1 = activeImg
                this.alIcon.nowStep = 0
             window.clearInterval(this.interval);
             this.interval = setInterval(this.bgMove, 30);
             this.alIcon.isOver = true
             this.alIcon.active = true
        },
        changeimg1(activeImg,num){
             this.alIcon.nowStep = 21
            this.textActive1 = -1
            window.clearInterval(this.interval);
             this.interval = setInterval(this.bgMove, 30);
             this.alIcon.isOver = false
             this.alIcon.active = true
        },
        handleScroll(){
             var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
                if(scrollTop > 460){
                               //防抖触发
            debounce(() => {
                this.$bus.$emit("Bgcolor",true,scrollTop);
            }, 300)
            }else{
                 debounce(() => {
                this.$bus.$emit("Bgcolor",false,scrollTop);
            }, 300)
            }
        },
        // 打开产品详情
        openApp(data,i){
            // this.$bus.$emit("isIndex", i);
             const newurl = this.$router.resolve({name: i == 1 ? 'endowloadHlyhDetail' : 'enHlyhSolution', query: {id: data.id,type:2}})
             window.open(newurl.href,'_blank')
        },
        // 打开轮播图详情页
        openBannerView(data){
             this.$bus.$emit("isBanner", true);
             if(data.particularType == '1'){
                 
                let path=data.particulars
               window.open(path,'_black')
             }else{
                  const newurl = this.$router.resolve({name: 'hlrjbannerDetail', query: {id: data.id}})
                    window.open(newurl.href,'_blank')
             }
        },
        // 判断为图片还是视频
        getResourceType(url) {
         const extension = url.split('.').pop().toLowerCase(); 
         if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') 
         { return 'img'; }
          else if (extension === 'mp4' || extension === 'avi' || extension === 'mov' || extension === 'wmv') 
         { return 'video'; } 
         else { return 'unknown'; } 
         },
        // 获取轮播图
        getBanner(){
              bannerList({
                channelFirst:'和隆软件官网',
              channelSecond:'官网首页'
            },'enterprise')
            .then(res => {
             this.banner = res.data
            })
            .catch(err => {
            })
        },
        // 获取主页配置
        getDetail(){
            this.list.moreImg = []
            this.list.moreTimg = []
              softList({id:1},'enterprise')
            .then(res => {
                let titleData 
                let picData
                let serveTextData
                let serveBotTextData
                   for (let i = 1; i < 5; i++) {
                        titleData = res.data.filter(item => item.attributeName ==  ('title' + i))
                        picData = res.data.filter(item => item.attributeName ==  ('pic' + i))
                        serveTextData = res.data.filter(item => item.attributeName ==  ('serveText' + i))
                        serveBotTextData = res.data.filter(item => item.attributeName ==  ('serveBotText' + i))
                      this.list['title' + i]  = titleData[0].attributeValue
                      this.list['pic' + i]  =  picData[0].attributeValue
                      this.list['serveText' + i]  =  serveTextData[0].attributeValue
                       this.list['serveBotText' + i]  =  serveBotTextData[0].attributeValue
                }    
                 // 合作伙伴赋值
                let moreImgData = res.data.filter(item => !item.attributeName.indexOf("moreImg"))       
                     for (const key in moreImgData) {
                this.list.moreImg.push(
                      {
                    url:moreImgData[key].attributeValue,
                    id:moreImgData[key].id,
                  }
                   )
                  }
                //   荣耀资质赋值
                let moreTimgData = res.data.filter(item => !item.attributeName.indexOf("moreTimg"))
                    for (const key in moreTimgData) {
                this.list.moreTimg.push(
                      {
                    url:moreTimgData[key].attributeValue,
                     id:moreImgData[key].id
                  }
                   )
                  } 
            })
            .catch(err => {
            })
        },
        // 获取产品分类
         async gethisClass(){
            await classList({officialType:2},'enterprise',1)
            .then(res => {
                this.loading = false
                if(res.code == 0){
                 this.itemList = res.data
               this.fristId = res.data[0].id
                this.gethisList(res.data[0].id,0)
                }
            })
            .catch(err => {
            })
        },
          // 获取分类
         async gethisClass1(){
            await classList({officialType:2},'enterprise',2)
            .then(res => {
                this.loading = false
                if(res.code == 0){
              this.itemList1 = res.data
               this.fristId1 = res.data[0].id
                this.fristName = res.data[0].name
                this.gethisList1(res.data[0].id,0)
                }
            })
            .catch(err => {
            })
        },
        // 获取产品列表
        gethisList(id,index){
            this.textActive = index
            ProductList({id:id,officialType:2},'enterprise',1)
            .then(res =>{
                this.dataList = res.data
            })
        },
        // 获取解决方案列表
        gethisList1(id,index,name){
            this.text1Active = index
            ProductList({id:id,officialType:2},'enterprise',2)
            .then(res =>{
                this.dataList1 = res.data
                if(name)  this.fristName = name
                // console.log(this.dataList1)
            })
        },
    },
      destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style lang="scss" scoped>
.homePage{
    .banner{
        position: relative;
        .banner-list{
            img{
                object-fit: cover;
            }
        }
        .banner-description{
            position: absolute;
            left: 8%;
            top: 144px;
            color: #fff;
            .name{
               font-size: 42px;
                color: #181818;
                line-height: 48px;
                margin-bottom: 15px;
                opacity: 1;
                min-height: 48px;
            }
            .description{
    height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    font-size: 16px;
    color: #181818;
    line-height: 30px;
    margin-bottom: 20px;
    opacity: 1;
            }
                .btn{
                     width: 138px;
                    cursor: pointer;
                    border: none;
                   height: 42px;
                   line-height: 42px;
                    font-size: 16px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: #2893f1;
                    border-radius: 1px;
                    margin-right: 20px;
                    padding: 0px 0;
                    color: #fff;
                    a{
                        color: #fff;
                    }
                }
        }
    }
    .homePage-content{
        background: #fff;
        position: relative;
        .endowloadDetail-contaniner1{
        padding: 50px 0 !important;
        background: #fff;
    }
        .coursebox{
        .course-1{
            text-align: left;
            position: relative;
            .ribbon-wrapper-1 {
  width: 106px;
  height: 108px;
  overflow: hidden;
  position: absolute;
  top: -6px;
  right: -6px; }

.ribbon-1 {
  font: bold 15px Sans-Serif;
  line-height: 18px;
  color: #333;
  text-align: center;
  text-transform: uppercase;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  position: relative;
  padding: 7px 0;
  left: -11px;
  top: 26px;
  width: 150px;
  background-color: #6daaab;
  color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.5px; }

.ribbon-1:before, .ribbon-1:after {
  content: "";
  border-top: 4px solid #4e7c7d;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  position: absolute;
  bottom: -4px; }

.ribbon-1:before {
  left: 0; }

.ribbon-1:after {
  right: 0; }

            .product-container{
                    max-width: 1540px;
            padding: 25px 15px 60px;
            flex-wrap: wrap;
            margin: 0 auto;
                    margin-bottom: 4px;
      .product-card{
        cursor: pointer;
       flex: 0 0 25%;
    position: relative;
    cursor: pointer;
    margin-top: 27px;
            background-color: #fff;
            box-shadow: 0 4px 20px rgba(19,19,51,0.04);
            border-radius: 4px;
            z-index: 1;
            font-size: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            transition: box-shadow .15s;
            img{
                width: 97%;
                height: 150px;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
            }
            .product-card-item-wrap{
             padding: 12px 16px 16px;
             .card-name{
                width: 97%;
                margin-bottom: 2px;
                overflow: hidden;
                color: #161616;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                white-space: nowrap;
                text-overflow: ellipsis;
             }
             .card-description{
                display: -webkit-box;
                margin-bottom: 12px;
                overflow: hidden;
                color: #b4b7c1;
                font-size: 14px;
                line-height: 22px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
             }
             .WordsLink_word-wrap{
                color: #2893f1;
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
                span{
                        display: inline-block;
                    font-size: 13px;
                    margin-left: 4px;
                }
             }
            }
      }  
    }
        }
    }
    .logo-box{
     background: #f4f5f7;
     .title{
        padding-top: 40px;
     }
    }
    .mobileSolutionbox{
        display: none;
    }
    .solutionbox{
        background: url('../../assets/images/solution.jpg') no-repeat 0 0;
        background-size: cover;
        position: relative;
        text-align: left !important;
        .mask{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 0;
            background: rgba(0,0,0,.5);
        }
        .title{
            color: #fff !important;
            position: relative;
            z-index: 1;
        }
        .solution{
            position: relative;
            z-index: 1;
            width: 1540px;
            margin: 0 auto;
            margin-top: 20px !important;
        .solutionLeft{
            padding: 0;
        position: relative;
        min-height: 650px;
        flex: 0 0 75%;
        max-width: 75%;
        .ltop{
            font-size: 20px;
            color: #fff;
        }
        .lbottom{
            margin: 0;
            margin-top: 30px;
            overflow: hidden;
            .item{
                width: 100%;
                overflow: hidden;
                .items {
                box-sizing: border-box;
                border: 1px solid rgba(255,255,255,0.25);
                padding: 15px 12px 20px 12px;
                margin-right: 14px;
                max-width: 260px;
                width: 23%;
                float: left;
                cursor: pointer;
                margin-bottom: 14px;
                min-height: 242px;
                span{
                margin: 0 auto;
                display: block;
                text-align: center;
                font-size: 36px;
                color: #fff;
                }
                .jftitle{
                 color: #fff;
                font-size: 14px;
                padding: 1rem 0;
                text-align: center;
                }
                .jftitle::after {
                    content: '';
                    display: block;
                    width: 2.42rem;
                    border-radius: 1px;
                    border-bottom: 2px solid #2893f1;
                    margin: 1.14rem auto;
                }
                .info{
                    text-align: left;
                    color: #c2c6d3;
                    letter-spacing: 0.4px;
                    line-height: 22px;
                     overflow: hidden;
                    -webkit-line-clamp: 2;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                }
            }
            }
        }
        }
        .solutionRight{
        flex: 0 0 25%;
        max-width: 25%;
         ul {
            display: block;
            margin: auto;
            position: relative;
         li{
            margin: auto auto 26px auto;
            text-align: left;
            width: 60%;
            cursor: pointer;
        .li-row{
            padding: 0px 0 0 15px;
            width: 100%;
            padding-left: 15px;
            color: #fff;
            span{
                font-size: 20px;
                line-height: 1;
                display: block;
            }
        }
        .li-row:hover{
            span{
                color: #2893f1;
            }
        }
        .text1-active-color{
             padding: 15px 15px;
         border-left: 4px solid #2893f1;
            background: rgb(255,255, 255 ,0.2);
            color: #2893f1;
        }
         }
        }
        }
        }
    }
        .apps-show{
            width: 100vw;
            margin: 0 auto;
            padding-top: 40px;
            text-align: center;
            .title{
                color: #181818;
                text-align: center;
                line-height: 48px;
                font-size: 28px;
                padding-bottom: 20px;
            }
            .apps-show-con{
                position: relative;
                .ace-view-fullColumn{
                    background: #f4f5f7;
                    .ace-view-center{
                    padding: 21px 15px 48px 15px;
                    max-width: 1540px!important;
                    margin: 0 auto;
                    flex-wrap: wrap;
                    .card{
                        flex:0 0 25%;
                        position: relative;
                        cursor: pointer;
                        margin-top: 27px;
                        // box-shadow: 0 5.7px 7.4px -17px rgb(0 0 0 / 1%), 0 10.8px 14px -17px rgb(0 0 0 / 2%), 0 15.9px 20.7px -17px rgb(0 0 0 / 2%), 0 22.2px 29.3px -17px rgb(0 0 0 / 3%), 0 32.6px 43px -17px rgb(0 0 0 / 4%), 0 62px 80px -17px rgb(0 0 0 / 7%);
                        img{
                            min-height: 280px;
                            object-fit: cover;
                            width: 97%;
                            margin: 0 auto;
                        }
                        .card-name{
                            position: absolute;
                            width: 97%;
                            height: 58px;
                            bottom: 0px;
                            left: 1.5%;
                            text-align: center;
                            background-color: rgba(0,0,0,0.5);
                            line-height: 58px;
                            color: #fff;
                        }
                        .card-name:hover{
                            color: #2893f1;
                        }
                    }
                    }
                }
            }
            .className {
                flex-wrap: wrap;
                margin: 0 auto;
                justify-content: center;
                .product-service-title-item{
                    width: 205px;
                    .product-service-title{
                        text-align: center;
                        height: 103px;
                        padding: 21px 0 19px;
                        cursor: pointer;
                        .title-img{
                            margin: 0 auto;
                            width: 64px;
                            height: 64px;
                            background-repeat: no-repeat;
                            background-position: 0 0;
                            background-size: 100%;
                             background-position-y: 0;
                        }
                        .title-desc{
                            margin-top: 4px;
                            text-align: center;
                            font-size: 14px;
                            color: #181818;
                            line-height: 24px;
                            font-weight: 400;
                            margin-bottom: 0;
                        }
                        .title-content-underLine{
                            transform: scaleX(0);
                            transform-origin: 50% 50%;
                            transition: transform .3s ease;
                            width: 100%;
                            margin: 11px auto 0;
                            border-bottom: 3px solid #2893f1;
                        }
                    }
                    .text-active-color{
                        .title-desc{
                            color: #2893f1;
                        }
                         .title-content-underLine{
                            transform: scale(1);
                         }
                    }
                    .text-active-color1{
                        color: #2893f1 !important;
                    }
                }
                .name{
                    .text{
                        padding-left: 10px;
                        font-size: 18px;
                        font-family:'PingFang SC';
                        font-weight: 400;
                        color: #333333;
                        line-height: 20px;
                        cursor: pointer;
                    }
                    
                }
            }
            .solutionClass{
                width: 25vw;
                position: relative;
                border-top:1px solid #ECECEC ;
                box-sizing: border-box;
                .solutionClass-item{
                    width: 100%;
                    height: 64px;
                    line-height: 64px;
                    border:1px solid #ECECEC;
                    border-top:none;
                    text-align: center;
                    cursor: pointer;
                }
                .text1-active-color{
                    color: #00Afff;
                }
            }
            .appProduct{
                background: #f4f5f7;
                height: 200px;
                // justify-content: space-between;
                flex-wrap: wrap;
                .card{
                    width: 19vw;
                    margin-bottom: 20px;
                    cursor: pointer;
                    position: relative;
                    img{
                        height: 236px;
                        object-fit: cover;
                        border-radius: 5px;
                        	box-shadow: 0 5.7px 7.4px -17px rgb(0 0 0 / 1%), 0 10.8px 14px -17px rgb(0 0 0 / 2%), 0 15.9px 20.7px -17px rgb(0 0 0 / 2%), 0 22.2px 29.3px -17px rgb(0 0 0 / 3%), 0 32.6px 43px -17px rgb(0 0 0 / 4%), 0 62px 80px -17px rgb(0 0 0 / 7%);
                    }
                    .card-name{
                        background: rgba(0,0,0,.6);
                        width: 100%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        color: #fff;
                        border-radius: 0 0 5px 5px;
                    }
                    .app-btn{
                        width: 132px;
                        height: 44px;
                        background: #3695FF;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 44px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        margin: -22px 0 0 -66px;
                        color: #fff;
                    }
                }
            }
            .solutionList{
                margin-left: 1vw;
                width: 54vw;
                .card-solution{
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .card-solution-item{
                        width: 17vw;
                        
                        cursor: pointer;
                        border:1px solid #ECECEC;
                        margin-bottom: 20px;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                            height: 180px;
                        }
                        .name{
                            font-size: 18px;
                            padding: 20px 0;
                        }
                    }
                  
                }
                  .item2{
                        justify-content: left;
                        .card-solution-item{
                            margin-right: 1vw;
                        }
                    }
            }
            
            .hz-logo{
                max-width: 1540px;
                 padding: 25px 15px 60px;
                flex-wrap: wrap;
                margin: 0 auto;
                .hz-img{
                        padding: 0;
                     flex: 0 0 15%;
                    margin-right: 20px;
                    margin-bottom: 20px;
                    img{
                     display: initial!important;
                    vertical-align: middle;
                    padding: 0 30px;
                    height: 80px;
                    width: 100%;
                    max-width: 264px;
                    }
                }
            }
                            .hz-logo-btn{
                    width: 138px;
                cursor: pointer;
                border: none;
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                text-align: center;
                vertical-align: middle;
                background-color: #2893f1;
                border-radius: 1px;
                padding: 0px 0;
                color: #fff;
                margin: 0px auto;
                margin-top: 10px;
                margin-bottom: 10px;
                cursor: pointer;
                }
            .honor-box{
            padding: 40px 0;
            max-width: 1540px;
            margin: auto;
            }   
            .honor-logo{
                padding-top: 20px;                
                flex-wrap: wrap;
                .honor-img{
                max-width: 373px;
                width: 20%;
                flex: 0 0 calc(20% - 30px);
                margin-bottom: 20px;
                    padding-right: 15px;
                    padding-left: 15px;
                .product-grid{
                    position: relative;
                    text-align: center;
                    .img{
                        background: #FFFFFF;
                        border: 1px solid #DFE3E6;
                        height: 250px;
                        line-height: 250px;
                        img{
                             max-width: 100%;
                        height: auto;
                        object-fit: cover;
                        max-height: 212px;
                        }
                    }
                }
                //    img{
                //     width: 100%;
                //     height: 100%;
                //    }
                }

.honor-img:hover {
    cursor: pointer;
    transition: all .2s;
    box-shadow: 0 5.7px 7.4px -17px rgb(0 0 0 / 1%), 0 10.8px 14px -17px rgb(0 0 0 / 2%), 0 15.9px 20.7px -17px rgb(0 0 0 / 2%), 0 22.2px 29.3px -17px rgb(0 0 0 / 3%), 0 32.6px 43px -17px rgb(0 0 0 / 4%), 0 62px 80px -17px rgb(0 0 0 / 7%);
}
                // .honor-img:hover{
                //     transform: scale(1.05);
                //     img:hover{
                //     transform: scale(1.05);
                // }
                // }
            }
        }
    }
    .homePage-bot{
        width: 100%;
        background: #212635;
        height: 150px;
        .bot-row{
            width: 80vw;
            justify-content: space-between;
            margin: 0 auto;
            height: inherit;
            .bot-coumln{
                img{
                    width: 40px;
                    height: 40px;
                }
                .footerNon{
                    padding-left: 20px;
                }
                .text{
                    color: #fff;
                    text-align: center;
                    font-size: 18px;
                }
                .text1{
                    color: #BDBFC3;
                    font-size: 14px;
                    padding-top: 5px;
                }
            }
        }
    }
}
@media screen and (max-width: 1600px){
    .honor-box,.hz-logo,.solution{
            max-width: 1200px !important;
            margin: auto !important;
     } 
}
@media (max-width: 640px){
    #homePage{
        .coursebox{
            .product-container{
                padding-top: 0;
                .product-card{
                    flex:  0 0 50%;
                    width: 50%;
                }
            }
        }
        .solutionbox{
            display: none;
        }
        .mobileSolutionbox{
            display: block;
            .ispadding{
                margin: 0 15px;
                .in-sidebar{
                    background: #FAFAFA;
                    padding: 0 30px;
                    overflow: hidden;
                    margin-bottom: 10px;
                    .titleTit{
                        margin: 0;
                        text-align: left;
                        position: relative;
                        line-height: 60px;
                        span{
                            font-size: 18px;
                            color: #4A4A4A;
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                    .titleTit::after{
                        content: '';
                        width: 4px;
                        height: 34px;
                        background: #2893f1;
                        display: inline-block;
                        vertical-align: middle;
                        position: absolute;
                        top: 13px;
                        left: -10px;
                    }
                    .isItem{
                        background: #fff;
                        padding: 0 20px 32px 18px;
                        .items{
                            padding-top: 36px;
                            span{
                                font-size: 26px;
                                line-height: 60px;
                            }
                            .planInfo{
                                line-height: 1;
                                margin-left: 20px;
                                .planInfo-title{
                                    font-size: 16px;
                                    color: #4A4A4A;
                                    line-height: 60px;
                                    cursor: pointer;
                                    text-align: left;
                                    position: relative;
                                    border-bottom: 2px solid #FAFAFA;
                                }
                                .info{
                                    font-size: 14px;
                                    color: #919191;
                                    margin-top: 12px;
                                    text-align: left;
                                }
                            }
                        }
                    }
                }
                .el-collapse-item:last-child{
                    margin-bottom: 0;
                }
            }
        }
        .hz-logo{
            width: 100%;
            padding: 0;
            .hz-img{
             flex: 0 0 30%; 
             margin-right: 9px;
            margin-bottom: 9px;
            img{
                padding: 0 10px;
                max-width: 100%;
                height: 60px;
            }
            }  
             .hz-logo-btn{margin-bottom: 30px;} 
        }
        .honor-logo{
            .honor-img{
                width: 50%;
            flex: 0 0 calc(50% - 30px);
                    }
        }
            .homePage-bot{
         background: #212635;
         padding: 50px 0;
         height: 150px !important;
         .bot-row{
            width: 90%;
            flex-wrap: wrap;
            .bot-coumln{
                width: 50%;
                padding-bottom: 30px;
                .text{
                    font-size: 12px;
                    text-align: left !important;
                }
                .text1{
                    font-size:12px !important
                }
                img{
                    width: 36px;
                    height: 36px;
                }

            }
         }
    }
     #banner{
        .el-carousel__container{
            height: auto;
        }
        .banner-list{
            height: inherit;
            img{
                height: 100% !important;
            }
        }
        .banner-description{
            top: 60px;
            // left: 50%;
            // top: 50% ;
            //  transform: translateX(-50%);
            //  margin-top: -135px;
            .name{
                font-size: 20px;
                line-height: 24px ;
                min-height: 24px;
            }
            .description{
                font-size: 13px;
                 line-height: 24px ;
                min-height: 24px;
                height: auto;
                width: 220px;
                 overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
            }
            .btn{
                margin-top: 0px;
            }
            .mobileVid{
                margin-left: 58%;
            }
        }
    }
    .homePage-content{
        width: 100%;
        overflow-x: hidden;
        .apps-show{
            .title{
                font-size: 20px;
                line-height: 28px;
            }
            .apps-show-con{
                .className {
                    .product-service-title-item{
                        width: 33%;
                        .title-img{
                            width: 64px;
                            height: 64px;
                        }
                        .title-desc{
                            font-size: 13px;
                        }
                        .title-content-underLine{
                            width: 80%;
                        }
                    }
                }
                .card{
                        flex: 0 0 50%;
                    max-width: 50%;
                    margin-top: 5px;
                    img{
                        min-height: 142px;
                    }
                    .card-name{
                        left: 4px;
                        bottom: 3px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
    }

}
::v-deep{
    @media (max-width: 640px){
         .banner{
        .el-carousel__container{
            height: auto !important;
            min-height: 270px;
        }
          .el-carousel__indicators--horizontal{
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    .el-carousel__button{
        width: 24px;
        opacity: 1;
    }
    .is-active{
        .el-carousel__button{
        background-color: #2893f1;
        }
        
    }
    }
    }
    }
    .el-carousel__indicators--horizontal{
    bottom: 35px;
    left: 9%;
    transform: translateX(-9%);
    .el-carousel__button{
        width: 36px;
        opacity: 1;
    }
    .is-active{
        .el-carousel__button{
        background-color: #2893f1;
        }
        
    }
    }
//     .el-loading-spinner{
//   /*这个是自己想设置的 gif 加载动图*/
//   background-image:url('../../assets/images/loading4.gif');
//   background-repeat: no-repeat;
//   background-size: 300px 300px;
//   height:300px;
//   width:100%;
//   background-position:center;
//   /*覆盖 element-ui 默认的 50% 因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了*/
//   top:40%;
//  }
// .el-loading-spinner .circular {
//  /*隐藏 之前 element-ui 默认的 loading 动画*/
 
//  display: none;
// }
// .el-loading-spinner .el-loading-text{
//  /*为了使得文字在loading图下面*/
//  margin:85px 0px;
// }
}
</style>
